import PropTypes from 'prop-types'
import SimpleAccordionItem from './SimpleAccordionItem';

const SimpleAccordion = ({ items = [], fields = { title: 'title', icon: 'icon', content: 'content' } }) => {


    return (
        <div className='w-full'>
            {
                items.map((elem, i) => {
                    return <SimpleAccordionItem key={'ai_' + i} title={elem[fields.title]} icon={elem[fields.icon]} content={elem[fields.content]} />
                })
            }
        </div>
    )
}

SimpleAccordion.propTypes = {
    items: PropTypes.array
}

export default SimpleAccordion
